<template>
  <div class="v-edit-tasks">
    <v-container fluid class="pt-0">
      <v-row class="line"></v-row>
      <v-row class="mt-0">
        <v-col cols="12" md="4" lg="3" xl="2" class="pt-0 projects-list">
          <div class="projects-list-container">
            <ProjectsList/>
          </div>
        </v-col>
        <v-col cols="12" md="8" lg="9" xl="10" class="pt-0" v-if="selectedProject">
          <TasksEditor :key="taskEditorUpdateKey"/>
        </v-col>
      </v-row>
    </v-container>
    <DetailsDialog v-if="showDialog.show" :key="selectedProject" />
  </div>
</template>
<script>
export default {
  name: 'EditTasks',
  components: {
    ProjectsList: () => import('@/components/tasks_editor/ProjectsList.vue'),
    TasksEditor: () => import('@/components/tasks_editor/TasksEditor.vue'),
    DetailsDialog: () => import('@/components/tasks_editor/DetailsDialog.vue')
  },
  computed: {
    showList () {
      return this.$store.getters.getOpenedFolders
    },
    selectedProject () {
      return this.$store.getters.getSelectedProject
    },
    showDialog () {
      return this.$store.getters.showDetailsDialog
    },
    user () {
      return this.$store.getters.getUser
    },
    employeeList () {
      return this.$store.getters.getEmployee
    },
    updateTasks () {
      return this.$store.getters.updateTasks
    },
    taskEditorUpdateKey () {
      return `update-by-selected-project-${this.selectedProject}-${this.updateTasks}`
    }
  },
  mounted () {
    this.getEmployeeList()
  },
  methods: {
    getEmployeeList () {
      if (!this.employeeList.length) {
        this.axios.get('/api/employeelist', {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(response => {
          this.$store.dispatch('setEmployeeList', { employeeList: response.data })
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .treeview::v-deep {
    .v-treeview-node__toggle {
      display: none;
    }
    .v-treeview-node__level {
      width: 10px;
    }
  }
  .projects-list-container {
    position: sticky;
    top: 60px;
  }
  .line {
    position: sticky;
    top: 48px;
    height: 12px;
    background-color: var(--hr-bg);
    z-index: 1;
    margin: 0;
  }
  .projects-list {
    z-index: 2;
  }
</style>
